import { render, staticRenderFns } from "./ListOnView.vue?vue&type=template&id=58e3d52a"
import script from "./ListOnView.vue?vue&type=script&lang=js"
export * from "./ListOnView.vue?vue&type=script&lang=js"
import style0 from "./ListOnView.vue?vue&type=style&index=0&id=58e3d52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports